import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Stack, Text, TextLink } from '@stepstone-genesis/components';
import { Trans } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../redux/hooks.js';
import { languageSpecificConfigSelector } from '../../../../redux/core/siteConfig/siteConfigSlice.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
const TERM_OF_USE = 'terms-of-use-link';
const PRIVACY_POLICY = 'privacy-policy-link';
export const RegistrationConsent = () => {
    const { termsOfUseUrl, dataProtectionPolicyUrl } = useAppSelector(languageSpecificConfigSelector);
    const { trackBtnClick } = useTrack('standard');
    const onTermsOfUse = () => {
        trackBtnClick({ uniqueName: 'termsOfUse' });
    };
    const onDataProtection = () => {
        trackBtnClick({ uniqueName: 'dataProtection' });
    };
    return (_jsx(Stack, { direction: "vertical", spacing: "spaceM", py: "spaceS", "data-testid": "registration-consent-container", children: _jsx(Text, { fontSize: ['fontSizeXs', 'fontSizeS'], color: 'colorGreyDark', lineHeight: "lineHeightXs", children: _jsx(Trans, { i18nKey: 'loginregistration.registration.legalNote', components: [
                    _jsx(TextLink, { "data-testid": TERM_OF_USE, variant: "bare", href: termsOfUseUrl, onClick: onTermsOfUse }, TERM_OF_USE),
                    _jsx(TextLink, { "data-testid": PRIVACY_POLICY, variant: "bare", href: dataProtectionPolicyUrl, onClick: onDataProtection }, PRIVACY_POLICY),
                ] }) }) }));
};
//# sourceMappingURL=RegistrationConsent.js.map